import { createSlice } from "@reduxjs/toolkit";
import config from "../../config";

const initialState = {
  initialAppLoading: true,
  isSidebarOpened: true,
  activePageID: config.defaultPathID,
  profileData: {},
  isBotSettingLoading: true,
  botSettingsData: {},
  reportData: {},
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setSiderbarOpened: (state, { payload }) => {
      state.isSidebarOpened = payload;
    },
    setActivePageID: (state, { payload }) => {
      state.activePageID = payload;
    },
    disableInitialLoading: (state) => {
      state.initialAppLoading = false;
    },
    setProfileData: (state, { payload }) => {
      state.profileData = payload;
    },
    setBotSettingsData: (state, { payload }) => {
      state.botSettingsData = payload;
    },
    setBotSettingsLoading: (state, { payload }) => {
      state.isBotSettingLoading = payload;
    },
    setReportData: (state, { payload }) => {
      state.reportData = payload;
    },
  },
});

export const {
  setSiderbarOpened,
  setActivePageID,
  disableInitialLoading,
  setProfileData,
  setBotSettingsData,
  setBotSettingsLoading,
  setReportData,
} = appSlice.actions;
export default appSlice.reducer;
